import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ControlHeader from './ControlHeader';
//NOTE: PLEASE UPDATE DatePicker ALSO AFTER EACH CHANGE IN TEXTBOX
//NOTE: PLEASE UPDATE DatePicker ALSO AFTER EACH CHANGE IN TEXTBOX
class TextBox extends React.Component {
  constructor(props) {
    super(props);
    if (props.value)//if store has value relative to this component, initialize the state value
      this.state = { value: props.value, error: "" };
    else//in case the store does not have any value for this component, just clear it
      this.state = { value: "", error: "" };
  }
  componentWillReceiveProps(props) {
    if (props.value && props.value !== this.state.value)//if store's value relative to this component change, update the state value
      this.setState({ value: props.value });
    else if (!props.value)//in case the store does not have any value for this component, just clear it
      this.setState({ value: "" });
    if (props.error && props.error !== this.state.error)
      this.setState({ error: props.error });
  }
  change = e => {
    this.setState({ value: e.target.value });
  }
  blur = e => {
    this.updateStore(e.target.value);
    const p = this.props;
    const isSearchBp =  (p.name == 'accountHolderInfo_residentInfo_firstName'
                         || p.name == 'accountHolderInfo_residentInfo_lastName'
                         || p.name == 'accountHolderInfo_residentInfo_dob'
                         || p.name == 'idType_DriverLicence'
                         || p.name == 'accountHolderInfo_businessInfo_businessName'
                         || p.name == 'idType_BusinessNumber'
                         || p.name == 'accountHolderInfo_phoneContact_primaryPhone');
    if(isSearchBp)
       p.dispatch({ type: 'SET_SEARCH_BP_CALLED', value: false });
  }
  updateStore(value) {
    const p = this.props;
    const error = this.validate(value);
    this.setState({ value, error });
    this.props.dispatch({ type: 'textbox', name: p.name, value: value });
  }
  validate(value) {
    const p = this.props;
    let error = null;
    if (!value && p.required)
      error = p.errorMsg ? p.errorMsg : p.title ? p.title + ' is required' : '';
    if (value && p.pattern) {
      let patt = new RegExp(p.pattern);
      if (!patt.test(value))
        error = p.patternErrorMsg ? p.patternErrorMsg : p.title ? p.title + ' is invalid' : '';
    }
    return error;
  }
  render() {
    const p = this.props;
    const s = this.state || {};
    //console.log(s);
    const input = p.isTextArea ?
      <textarea rows={p.rows || "4"} cols={p.cols || "50"} id={p.id || p.name} name={p.name} value={s.value} className="form-control"
        onChange={this.change} onBlur={this.blur} placeholder={p.placeholder} disabled={p.disabled} />
      :
      (p.isPassword ?
          <div className="input-group" style={{ "width": "100%"}} >
              <input type={p.isShowPassword ? "password" : "text"}  id={p.id || p.name} name={p.name} value={s.value} className="form-control"
                onChange={this.change} onBlur={this.blur} placeholder={p.placeholder} disabled={p.disabled} maxLength={p.maxLength} />
                {
                  !p.hideEye ?
                  <span className="input-group-addon" onClick={p.onShowPassword}><i className="fa fa-eye"></i></span> 
                  : null
                }
                  
           </div>
            :
        <input type= "text" id={p.id || p.name} name={p.name} value={s.value} className="form-control"
            onChange={this.change} onBlur={this.blur} placeholder={p.placeholder} disabled={p.disabled} maxLength={p.maxLength} />
      );
    
     return (
      <div className={s.error ? 'has-error' : ''}>
        {p.title ? <ControlHeader {...p} />:null}
        {p.customClass ?
          <div className="row"><div className={p.customClass}>{input}</div></div>
          :
          <div>{input}</div>
        }
        {s.error ? <label className="control-label has-error validationMessage">{s.error}</label> : null}
      </div>
    );
  }
}
TextBox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  errorMsg: PropTypes.string,
  patternErrorMsg: PropTypes.string,
};
const mapStateToProps = (state, props) => {
  return {
    value: state.form && state.form[props.name],
    error: state.form && state.form.errors && state.form.errors[props.name],
  };
};
export default connect(mapStateToProps)(TextBox);